export default __webpack_public_path__ + "static/careers-benefits-block1-icon02.url-374e2c3325450c7759ba4f0fc2206d09.svg";